// extracted by mini-css-extract-plugin
export var avatarContainer = "_ex-0";
export var gray = "_ex-f";
export var green = "_ex-c";
export var icon = "_ex-9";
export var image = "_ex-1";
export var lg = "_ex-6";
export var md = "_ex-5";
export var presenceDot = "_ex-b";
export var red = "_ex-d";
export var sm = "_ex-4";
export var status = "_ex-a";
export var xl = "_ex-7";
export var xs = "_ex-3";
export var xxl = "_ex-8";
export var xxs = "_ex-2";
export var yellow = "_ex-e";